<template>

  <div class="w-table-wrap" style="max-height: 1200px;">
    <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
      <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI TERNAKAN'" >
         <template #title>
            SENARAI TERNAKAN
            <w-flex justify-end class="mt2">
               <w-button @click="isMinimizedList = !isMinimizedList">
                  <template v-if="isMinimizedList">
                     <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                  </template>
                  <template v-else>
                     <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                  </template>
               </w-button>
            </w-flex>
         </template>
        <div v-show="!isMinimizedList">
        <div class="w-table-wrap" style="max-height: 1400px;" >
        <div class="w-flex wrap smd-column" >
          <div class="grow " style="line-height: 35px">
            <table >
              <tbody>
              <tr class="row_data">
                 <td><b>Tujuan PD</b></td>
                 <td><b>:</b></td>
                 <td>Pemeriksaan Kebuntingan Selepas AI</td>
              </tr>
              <tr class="row_data">
                 <td><b>Tarikh Pemeriksaan Kebuntingan AI</b><i aria-hidden="true" style=" color: red;">*</i></td>
                 <td><b>:</b></td>
                 <td>
                  <template v-if="datas.juruteknik_pd_id == $page.props.auth.user.id && (datas.lkp_status_id==34 ||datas.lkp_status_id==39|| datas.lkp_status_id==27)">
                  <w-input type="date" v-model="datas.tarikh_pemeriksaan_art" outline :validators="[validators.required]"></w-input>
                  </template>
                  <template v-else>
                    {{$zutil.dateformat(datas.tarikh_pemeriksaan_art)}}
                  </template>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <br>
        <div class="table-profil-scrol">
          <table class="w-table" color="light" >
            <thead>
              <tr>
                <th class="w-table__header  text-center" width="1%">BIL</th>
                <th class="w-table__header  text-center">NO KES AI</th>
                <th class="w-table__header  text-center">ID | NAMA TERNAKAN</th>
                <th class="w-table__header  text-center">BAKA</th>
                <th class="w-table__header  text-center">TARIKH BERANAK TERDAHULU</th>
                <th class="w-table__header  text-center">TARIKH SUNTIKAN TERDAHULU/NAMA JURUTEKNIK/JURUSUNTIK</th>
                <th class="w-table__header  text-center">KAEDAH PEMERIKSAAN<i aria-hidden="true" style=" color: red;">*</i></th>
                <th class="w-table__header  text-center">STATUS<i aria-hidden="true" style=" color: red;">*</i></th>
                <th class="w-table__header  text-center">USIA KEBUNTINGAN (BULAN)</th>
                <th class="w-table__header  text-center">TARIKH JANGKAAN BERANAK</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="ternakan_list.length == 0">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-center" colspan="5"> Tiada Data.</td>
                </tr>
              </template>
              <template v-for="(dt, ind) in ternakan_list">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-left" >{{ind+1}}</td>
                  <td class="w-table__cell text-left" style="margin:3px;"><div style="width: 210px"></div>{{dt.no_kes}}</td>
                  <td class="w-table__cell text-left" style="margin:3px;"><div style="width: 210px"></div>{{dt.ternakan_nama}}</td>
                  <td class="w-table__cell text-left" style="margin:3px;"><div style="width: 150px"></div>{{dt.baka}}</td>
                  <td class="w-table__cell text-left" style="margin:3px;"><div style="width: 150px"></div>{{dt.tarikh_beranak_terdahulu}}</td>
                  <td class="w-table__cell text-left" style="margin:3px;"><div style="width: 150px"></div>-</td>
                  <td class="w-table__cell text-left"><div style="width: 210px"></div>
                    <template v-if="datas.juruteknik_pd_id == $page.props.auth.user.id && (datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27)">
                        <template v-if="dt.lkp_status_id == 28">
                           {{dt.lkpKaedahPemeriksaan_keterangan}}
                        </template>
                        <template v-else>
                           <w-select style="margin:20px;" placeholder="Pilih Satu.." outline :items="kaedah_pemeriksaan" v-model="dt.lkp_kaedah_pemeriksaan_id" :validators="[validators.required]"/>
                        </template>
                    </template>
                    <template v-else>
                      {{dt.lkpKaedahPemeriksaan_keterangan}}

                    </template>
                  </td>
                  <td class="w-table__cell text-left" ><div style="width: 210px"></div>

                    <template v-if="datas.juruteknik_pd_id == $page.props.auth.user.id && (datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27)">
                        <template v-if="dt.lkp_status_id == 28">
                           <template v-if="dt.bunting_art==1">BUNTING</template><template v-else>TIDAK BUNTING</template>
                        </template>
                        <template v-else>
                           <w-select style="margin:5px;" placeholder="Pilih Satu.." class="mt4" outline :items="bunting" @input="getTarikhJangkaan(dt, dt.usia_bunting_art)" v-model="dt.bunting_art" :validators="[validators.required]"/>
                        </template>
                    </template>
                    <template v-else>
                      <template v-if="dt.bunting_art==1">BUNTING</template><template v-else>TIDAK BUNTING</template>
                    </template>
                  </td>
                  <template v-if="datas.juruteknik_pd_id == $page.props.auth.user.id && (datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27)">
                    <td class="w-table__cell text-left" ><div style="width: 210px"></div>
                        <template v-if="dt.lkp_status_id == 28">
                            {{dt.usia_bunting_art}}
                        </template>
                        <template v-else>
                           <w-input style="margin:5px;" min="0" type="number" placeholder="Sila masukan.." class="mt4" outline v-model="dt.usia_bunting_art" @change="getTarikhJangkaan(dt, dt.usia_bunting_art)" :disabled="dt.bunting_art==2"/>
                        </template>
                    </td>
                  </template>
                  <template v-else>
                    <td class="w-table__cell text-right" >
                      {{dt.usia_bunting_art}}
                    </td>
                  </template>
                  <td class="w-table__cell text-center" style="margin:5px;"><div style="width: 110px"></div>
                    {{$zutil.dateformatBulanTahun(dt.jankaan_kelahiran_art)}}
                  </td>
                 
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        </div>
        </div>
      </w-card><br>

      <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'CAJ PERKHIDMATAN KEBUNTINGAN AI'">
         <template #title>
            CAJ PERKHIDMATAN AI
            <w-flex justify-end class="mt2">
               <w-button @click="isMinimizedCaj = !isMinimizedCaj">
                  <template v-if="isMinimizedCaj">
                     <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                  </template>
                  <template v-else>
                     <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                  </template>
               </w-button>
            </w-flex>
         </template>
         <div v-show="!isMinimizedCaj">
          <div class="w-flex wrap smd-column" >
             <div class="grow " style="line-height: 35px">
               <table width="100%">
                <tbody>
                  <tr class="row_data">
                     <td width="1%" valign="top"><b>1.</b></td>
                     <td width="22%" valign="top"><b>Konsultasi / Perkhidmatan</b></td>
                     <td width="1%" valign="top"><b>:</b></td>
                     <td width="20%" valign="top">
                        <div v-if="datas.juruteknik_pd_id == $page.props.auth.user.id && (datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27)">
                           <w-radios
                             :items="ya_tidak"
                             v-model="datas.konsutasi_pemeriksaan_ya_tidak"
                             @input="kiraan_caj(datas)"
                             inline class="mr2"
                             >
                           </w-radios>
                        </div>
                        <div v-else>
                           <w-tag
                             class="mr4"
                             bg-color="primary"
                             round>
                              <template v-if="datas.konsutasi_pemeriksaan_ya_tidak==1">Berbayar</template><template v-else>Subsidi</template>
                           </w-tag>
                        </div>
                     </td>
                     <td width="1%" valign="top">
                            RM
                     </td>
                     <td width="20%" valign="top">
                        <div v-if="datas.juruteknik_pd_id == $page.props.auth.user.id && (datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27)">
                            <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.konsutasi_pemeriksaan" @input="kiraan_caj(datas)"  outline/>
                        </div>
                        <div v-else>
                            <template v-if="datas.konsutasi_pemeriksaan==null">-</template>
                            <template v-else>{{$zutil.formatDecimal(datas.konsutasi_pemeriksaan)}}</template>
                        </div>
                     </td>
                     <td width="35%"></td>
                  </tr>
                  </tbody>
              </table>
           </div>
        </div>

        <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table width="100%">
                <tbody>
                  <tr class="row_data">
                     <td width="1%" valign="top"><b>2.</b></td>
                     <td width="22%" valign="top"><b>Caj Pemeriksaan PD (RM)</b></td>
                     <td width="1%" valign="top"><b>:</b></td>
                     <td width="20%" valign="top">
                        <div v-if="datas.juruteknik_pd_id == $page.props.auth.user.id && (datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27)">
                           <!-- <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.caj_pemeriksaan_pd" @input="kiraan_caj(datas)" :validators="[validators.required]" outline/> -->
                            <w-radios
                             :items="ya_tidak"
                             v-model="datas.bayar_pemeriksaan_pd"
                             @input="kiraan_caj(datas)"
                             inline class="mr2"
                             >
                           </w-radios>
                        </div>
                        <div v-else>
                            <w-tag
                             class="mr4"
                             bg-color="primary"
                             round>
                              <template v-if="datas.bayar_pemeriksaan_pd==1">Berbayar</template><template v-else>Subsidi</template>
                           </w-tag>
                        </div> 
                     </td>
                     <td valign="top" width="1%%">
                            RM
                     </td>
                     <td valign="top" width="20%">
                        <div v-if="datas.juruteknik_pd_id == $page.props.auth.user.id && (datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27)">
                           <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.caj_pemeriksaan_pd" @input="kiraan_caj(datas)" outline/>
                       </div>
                       <div v-else>
                           <template v-if="datas.caj_pemeriksaan_pd==null">-</template>
                           <template v-else>{{$zutil.formatDecimal(datas.caj_pemeriksaan_pd)}}</template>
                       </div>
                     </td>
                     <td width="35%"></td>
                  </tr>
                  </tbody>
               </table>
           </div>
        </div>

        <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table width="100%">
                <tbody>
                  <tr class="row_data">
                     <td valign="top" width="1%"><b>3.</b></td>
                     <td valign="top" width="22%"><b>Caj Perjalanan (RM)</b></td>
                     <td valign="top" width="1%"><b>:</b></td>
                     <td valign="top" width="20%">
                        <div v-if="datas.juruteknik_pd_id == $page.props.auth.user.id && (datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27)">
                           <!-- <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.pengangkutan" @input="kiraan_caj(datas)" :validators="[validators.required]" outline/> -->
                            <w-radios
                             :items="ya_tidak"
                             v-model="datas.bayar_pengangkutan_pemeriksaan"
                             @input="kiraan_caj(datas)"
                             inline class="mr2"
                             >
                           </w-radios>
                        </div>
                        <div v-else>
                            <w-tag
                             class="mr4"
                             bg-color="primary"
                             round>
                              <template v-if="datas.bayar_pengangkutan_pemeriksaan==1">Berbayar</template><template v-else>Subsidi</template>
                           </w-tag>
                        </div> 
                     </td>
                     <td valign="top" width="1%">RM</td>
                     <td valign="top" width="20%">  
                        <div v-if="datas.juruteknik_pd_id == $page.props.auth.user.id && (datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27)">
                            <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.pengangkutan_pemeriksaan" @input="kiraan_caj(datas)" outline/>
                        </div>
                        <div v-else>
                           <template v-if="datas.pengangkutan_pemeriksaan==null">-</template>
                           <template v-else>{{$zutil.formatDecimal(datas.pengangkutan_pemeriksaan)}}</template>
                        </div>
                     </td>
                     <td width="35%"></td>
                  </tr>
                  </tbody>
               </table>
           </div>
        </div>
            
        <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table width="100%">
                <tbody>
                  <tr class="row_data">
                     <td valign="top" width="1%"><b>4.</b></td>
                     <td valign="top" width="22%"><b>Caj Lain-Lain (Jika Ada) (RM)</b></td>
                     <td valign="top" width="1%"><b>:</b></td>
                     <td valign="top" width="20%">
                        <div v-if="datas.juruteknik_pd_id == $page.props.auth.user.id && (datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27)">
                           <!-- <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.pengangkutan" @input="kiraan_caj(datas)" :validators="[validators.required]" outline/> -->
                            <w-radios
                             :items="ya_tidak"
                             v-model="datas.bayar_caj_lain_pemeriksaan"
                             @input="kiraan_caj(datas)"
                             inline class="mr2"
                             >
                           </w-radios>
                        </div>
                        <div v-else>
                            <w-tag
                             class="mr4"
                             bg-color="primary"
                             round>
                              <template v-if="datas.bayar_caj_lain_pemeriksaan==1">Berbayar</template><template v-else>Subsidi</template>
                           </w-tag>
                        </div> 
                     </td>
                     <td valign="top" width="1%">RM</td>
                     <td valign="top" width="20%">
                        <div v-if="datas.juruteknik_pd_id == $page.props.auth.user.id && (datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27)">
                           <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.caj_lain_pemeriksaan" @input="kiraan_caj(datas)" outline/>
                        </div>
                        <div v-else>
                           <template v-if="datas.caj_lain_pemeriksaan==null">-</template>
                           <template v-else>{{$zutil.formatDecimal(datas.caj_lain_pemeriksaan)}}</template>
                        </div>
                     </td>
                     <td width="35%"></td>
                  </tr>
                <template v-if="datas.caj_lain_pemeriksaan!=0">
                  <tr class="row_data">
                     <td width="1%"><b></b></td>
                     <td width="22%"><b>Nyatakan</b></td>
                     <td width="1%"><b>:</b></td>
                     <td colspan="2">
                        <div v-if="datas.juruteknik_pd_id == $page.props.auth.user.id && (datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27)">
                              <z-input style="margin:5px;" label="" class="mt4" v-model="datas.nyatakan_pemeriksaan" @input="kiraan_caj(datas)" placeholder="Sila Masukan.." :validators="[validators.required]" outline/>
                        </div>
                        <div v-else>
                            {{datas.nyatakan_pemeriksaan}}
                        </div> 
                     </td>
                     <td colspan="2"></td>
                  </tr>
                </template>
                <template v-else>
                  <tr class="row_data">
                     <td colspan="7"><div style="margin:17px;" class="fw-normal my1 fs-1"></div>  </td>
                  </tr>
                </template>
                </tbody>
               </table>
           </div>
       </div>
       <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table width="100%">
                <tbody>
                  <tr class="row_data">
                     <td width="23%"><b>Jumlah Caj Keseluruhan</b></td>
                     <td valign="top" width="1%"><b>:</b></td>
                     <td valign="top" width="1%"><b>RM</b></td>
                     <td valign="top" width="20%">
                        <b>{{$zutil.formatDecimal(datas.keseluruhan_pemeriksaan)}}</b>
                     </td>
                     <td width="55%"></td>
                  </tr>
                  <tr class="row_data">
                     <td width="23%"><b>Jumlah Caj Yang Perlu Dibayar</b></td>
                     <td valign="top" width="1%"><b>:</b></td>
                     <td valign="top" width="1%"><b>RM</b></td>
                     <td valign="top" width="20%">
                        <b>{{$zutil.formatDecimal(datas.perlu_bayar_pemeriksaan)}}</b>
                     </td>
                     <td width="55%"></td>
                  </tr>
                  <tr class="row_data">
                     <td width="23%"><b>Jumlah Caj Subsidi Kerajaan</b></td>
                     <td valign="top" width="1%"><b>:</b></td>
                     <td valign="top" width="1%"><b>RM</b></td>
                     <td valign="top" width="20%">
                        <b>{{$zutil.formatDecimal(datas.subsidi_pemeriksaan)}}</b>
                     </td>
                     <td width="55%"></td>
                  </tr>
                  </tbody>
               </table>
            </div>
            </div>
         </div>
      </w-card>

      <w-flex class="mt3" wrap align-center justify-end v-if="(datas.lkp_status_id==34||datas.lkp_status_id==39|| datas.lkp_status_id==27)">
        <w-button class="my1" :loading="loading" :disabled="loading" type="submit" v-if="datas.juruteknik_pd_id == $page.props.auth.user.id">
          <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
        </w-button>
        &nbsp;
      </w-flex>

    </w-form>
  </div>
</template>

<script>
export default {
  name: "Pemilik",
  props:{
    d_data: [Array, Object],
    d_segmenName: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.semakan.ai-aiman',
      form : {},
      cek_tarikh_pemeriksaan: false,
      datas : this.d_data,
      lkp_berahi : [],
      loading:false,
      ternakan_list:[],
      list_stock:[],
      bunting:[
        {value: 1, label: "BUNTING"},
        {value: 2, label: "TIDAK BUNTING"}
      ],
      kaedah_pemeriksaan: [],
      validators: {
          required: (value) => !!value || "Medan ini wajib diisi",
          consent: (value) => !!value || "You must agree",
          email: (value) =>
              !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
              "Sila Semak Format Email",
          numeric: (value) => value !== '' || !isNaN(value) || "Medan Ini Wajib Numeric",
      },
      total_harga:0,

      ya_tidak:[
         {value: 1, label: "Berbayar"},
         {value: 2, label: "Subsidi"},
      ],
      isMinimizedList: false,
      isMinimizedCaj: false,
      
    }
  },
  methods:{
    calculateDueMonth(currentDate, pregnancyDays, monthsCompleted) {
        // kiraan by bulan
        const averageDaysPerMonth = pregnancyDays / 9;
        const daysElapsed = monthsCompleted * averageDaysPerMonth;
        const remainingDays = pregnancyDays - daysElapsed;
        const dueDate = new Date(currentDate);
        dueDate.setDate(dueDate.getDate() + remainingDays);
        // const dueMonth = dueDate.toLocaleString('default', { month: 'long' });
        // const dueYear = dueDate.getFullYear();

        // return `1 ${dueMonth} ${dueYear}`;
        const yyyy = dueDate.getFullYear();
        const mm = String(dueDate.getMonth() + 1).padStart(2, '0');
        const dd = String(dueDate.getDate()).padStart(2, '0');

        return `${yyyy}-${mm}-${dd}`;
    },

    getTarikhJangkaan(dt, usia_bunting_art){

      if(dt.bunting_art==1){
        const bunting_ternakan = this.datas.bunting_ternakan;
        const tarikh_pemeriksaan_art = new Date(this.datas.tarikh_pemeriksaan_art);

        dt.jankaan_kelahiran_art = this.calculateDueMonth(tarikh_pemeriksaan_art, bunting_ternakan, usia_bunting_art); 
      }else{
         dt.jankaan_kelahiran_art=null;
        dt.usia_bunting_art =0;
      }
    },
    kiraan_caj(){
        const konsutasi_pemeriksaan = this.datas.konsutasi_pemeriksaan ? this.datas.konsutasi_pemeriksaan : 0;
        const caj_pemeriksaan_pd = this.datas.caj_pemeriksaan_pd ? this.datas.caj_pemeriksaan_pd : 0;
        const pengangkutan_pemeriksaan = this.datas.pengangkutan_pemeriksaan ? this.datas.pengangkutan_pemeriksaan : 0;
        const caj_lain_pemeriksaan = this.datas.caj_lain_pemeriksaan ? this.datas.caj_lain_pemeriksaan : 0;
        const keseluruhan_pemeriksaan = this.datas.keseluruhan_pemeriksaan ? this.datas.keseluruhan_pemeriksaan : 0;
            if(this.datas.jenis_pengguna_pemohon == 1){

                this.datas.subsidi_pemeriksaan = 0;
                this.datas.keseluruhan_pemeriksaan = 0;
                if(this.datas.konsutasi_pemeriksaan_ya_tidak==2){ 
                    // var subsidi_pemeriksaan = Number(pengangkutan_pemeriksaan) + Number(caj_pemeriksaan_pd) + Number(caj_lain_pemeriksaan);
                    // this.datas.perlu_bayar_pemeriksaan = Number(konsutasi_pemeriksaan);
                    var subsidi_pemeriksaan = Number(konsutasi_pemeriksaan);
                }else{
                    // var subsidi_pemeriksaan = Number(pengangkutan_pemeriksaan) + Number(caj_pemeriksaan_pd) + Number(konsutasi_pemeriksaan) + Number(caj_lain_pemeriksaan);
                    //  this.datas.perlu_bayar_pemeriksaan = 0;
                     var subsidi_pemeriksaan = 0;
                }

                if(this.datas.bayar_pengangkutan_pemeriksaan==2){ 
                    var subsidi_pengangkutan_pemeriksaan =  Number(pengangkutan_pemeriksaan);
                }else{
                    var subsidi_pengangkutan_pemeriksaan = 0;
                }

                if(this.datas.bayar_caj_lain_pemeriksaan==2){ 
                    var subsidi_lain_pemeriksaan =  Number(caj_lain_pemeriksaan) ;
                }else{
                    var subsidi_lain_pemeriksaan = 0;
                }

                if(this.datas.bayar_pemeriksaan_pd==2){ 
                    var subsidi_pemeriksaan_pd =  Number(caj_pemeriksaan_pd) ;
                }else{
                    var subsidi_pemeriksaan_pd = 0;
                }
                

                // this.datas.subsidi_pemeriksaan = subsidi_pemeriksaan;
            }else{

                this.datas.keseluruhan_pemeriksaan = 0;
                this.datas.perlu_bayar_pemeriksaan = 0;
                // if(this.datas.konsutasi_pemeriksaan_ya_tidak==2){ 
                //   this.datas.subsidi_pemeriksaan = Number(konsutasi_pemeriksaan);
                // }
                // this.datas.keseluruhan_pemeriksaan = Number(pengangkutan_pemeriksaan) + Number(caj_lain_pemeriksaan) + Number(caj_pemeriksaan_pd);
                // this.datas.perlu_bayar_pemeriksaan = Number(keseluruhan_pemeriksaan);

                if(this.datas.konsutasi_pemeriksaan_ya_tidak==2){ 
                    var subsidi_pemeriksaan = Number(konsutasi_pemeriksaan);
                }else{
                     var subsidi_pemeriksaan = 0;
                }

                if(this.datas.bayar_pengangkutan_pemeriksaan==2){ 
                    var subsidi_pengangkutan_pemeriksaan =  Number(pengangkutan_pemeriksaan);
                }else{
                    var subsidi_pengangkutan_pemeriksaan = 0;
                }

                if(this.datas.bayar_caj_lain_pemeriksaan==2){ 
                    var subsidi_lain_pemeriksaan =  Number(caj_lain_pemeriksaan) ;
                }else{
                    var subsidi_lain_pemeriksaan = 0;
                }

                if(this.datas.bayar_pemeriksaan_pd==2){ 
                    var subsidi_pemeriksaan_pd =  Number(caj_pemeriksaan_pd) ;
                }else{
                    var subsidi_pemeriksaan_pd = 0;
                }
            }

        this.datas.keseluruhan_pemeriksaan = Number(pengangkutan_pemeriksaan) + Number(konsutasi_pemeriksaan) + Number(caj_pemeriksaan_pd) + Number(caj_lain_pemeriksaan);

        this.datas.subsidi_pemeriksaan = subsidi_pemeriksaan_pd + subsidi_pemeriksaan + subsidi_pengangkutan_pemeriksaan + subsidi_lain_pemeriksaan;
        this.datas.perlu_bayar_pemeriksaan = (Number(pengangkutan_pemeriksaan) + Number(konsutasi_pemeriksaan) + Number(caj_pemeriksaan_pd) + Number(caj_lain_pemeriksaan)) - subsidi_pemeriksaan_pd - subsidi_pemeriksaan -  subsidi_pengangkutan_pemeriksaan - subsidi_lain_pemeriksaan;
      // console.log(datas.perlu_bayar)
    },
    lkpPenentuan()
    {
      this.$zcomm.get(this.api_service + 'lookup/penentuan_ai', {}).then(res => {
        this.lkp_penentuan_ai = res
      })
    },
    lkpKategoriSemen()
    {
      this.$zcomm.get(this.api_service + 'lookup/kategori_semen', {}).then(res => {
        this.kategori_semen = res
      })
    },
    lkpKaedahPemeriksaan()
    {
      this.$zcomm.get(this.api_service + 'lookup/kaedah_pemeriksaan', {}).then(res => {
        this.kaedah_pemeriksaan = res
      })
    },
    getHarga(dt){
      for (var b in this.list_stock) {
        if(this.list_stock[b].value==dt.se_stock_id){
          dt.harga_straw = this.list_stock[b].harga;
          dt.max_kuantiti_straw = this.list_stock[b].baki;
        }
      }
    },
    cekBakiStraw(dt){
      if(dt.bil_straw > dt.max_kuantiti_straw){
        dt.bil_straw = dt.max_kuantiti_straw;
      }
    },

    getTernakan(){
      // ternakan list
      if(this.datas.tarikh_pemeriksaan_art == null){
        this.cek_tarikh_pemeriksaan = false;
      }else{
        this.cek_tarikh_pemeriksaan = true;
      }
      for (var b in this.datas.ternakan_list) {
        if(this.datas.ternakan_list[b].bunting==2 && this.datas.ternakan_list[b].status_pemeriksaan ==1){
          this.getHarga(this.datas.ternakan_list[b]);
          this.ternakan_list.push({
            id:this.datas.ternakan_list[b].id,
            art_id:this.datas.ternakan_list[b].art_id,
            lkp_status_id: this.datas.ternakan_list[b].lkp_status_id,
            bil_straw:this.datas.ternakan_list[b].bil_straw,
            bunting:this.datas.ternakan_list[b].bunting,
            harga_straw:this.datas.ternakan_list[b].harga_straw,
            id_ternakan_kode:this.datas.ternakan_list[b].id_ternakan_kode,
            jankaan_biang_semula:this.jankaanBiangSemula(this.datas.ternakan_list[b].jankaan_biang_semula),
            jankaan_kelahiran:this.datas.ternakan_list[b].jankaan_kelahiran,
            lkpBerahi_keterangan:this.datas.ternakan_list[b].lkpBerahi_keterangan,
            lkp_berahi_id:this.datas.ternakan_list[b].lkp_berahi_id,
            no_kes:this.datas.ternakan_list[b].no_kes,
            se_stock_id:this.datas.ternakan_list[b].se_stock_id,
            skor_badan:this.datas.ternakan_list[b].skor_badan,
            status:this.datas.ternakan_list[b].status,
            ternakan_id:this.datas.ternakan_list[b].ternakan_id,
            usia_bunting:this.datas.ternakan_list[b].usia_bunting,
            usia_bunting:this.datas.ternakan_list[b].usia_bunting,
            list_stock: this.datas.ternakan_list[b].list_stock,
            max_kuantiti_straw:this.datas.ternakan_list[b].max_kuantiti_straw,
            no_batch_keterangan:this.datas.ternakan_list[b].no_batch_keterangan,
            lkp_penentuan_ai_id:this.datas.ternakan_list[b].lkp_penentuan_ai_id,
            ternakan_nama:this.datas.ternakan_list[b].ternakan_nama,
            lkp_kategori_semen_id: this.datas.ternakan_list[b].lkp_kategori_semen_id,
            tarikh_beranak_terdahulu : this.datas.ternakan_list[b].tarikh_beranak_terdahulu,
            baka : this.datas.ternakan_list[b].baka,
            lkpKaedahPemeriksaan_keterangan: this.datas.ternakan_list[b].lkpKaedahPemeriksaan_keterangan,
            lkp_kaedah_pemeriksaan_id: this.datas.ternakan_list[b].lkp_kaedah_pemeriksaan_id,
            bunting_art: this.datas.ternakan_list[b].bunting_art,
            usia_bunting_art: this.datas.ternakan_list[b].usia_bunting_art,
            jankaan_kelahiran_art: this.datas.ternakan_list[b].jankaan_kelahiran_art,
          })
        }
      }
      this.kiraan_caj();
    },

    //belum benar
    bilanganInseminasi() {
      const tarikh_pemeriksaan = new Date(this.datas.tarikh_pemeriksaan);
      const tarikh_sekarang = new Date();

      const batasTanggal = new Date(tarikh_sekarang);
      batasTanggal.setMonth(batasTanggal.getMonth() + 3);
      if(tarikh_pemeriksaan == tarikh_sekarang){
        return 1;
      }else if(tarikh_pemeriksaan > tarikh_sekarang && tarikh_pemeriksaan <= batasTanggal){
        return 2;
      }else if(tarikh_pemeriksaan > batasTanggal){
         return 3;
      }
      return 1;
      // return formattedDate;
    },

    jankaanBiangSemula(tarikh){
      const tarikh_pemeriksaan = new Date(this.datas.tarikh_pemeriksaan);
      tarikh_pemeriksaan.setDate(tarikh_pemeriksaan.getDate() + this.datas.ternakan_biang_semula); //tambah  hari untuk lembu
      const formattedDate = `${tarikh_pemeriksaan.getFullYear()}-${String(tarikh_pemeriksaan.getMonth() + 1).padStart(2, '0')}-${String(tarikh_pemeriksaan.getDate()).padStart(2, '0')}`;
      return formattedDate;
    },

    validateForm() {
      this.loading=true;
      let isValid = true;
      var cek_tarikh_pemeriksaan = false;
      if(this.datas.tarikh_pemeriksaan_art == null){
        var cek_tarikh_pemeriksaan = false;
      }else{
        var cek_tarikh_pemeriksaan = true;
      }
      if(cek_tarikh_pemeriksaan===false){
        isValid = false;
        this.loading=false;
      }
      if (this.cek_tarikh_pemeriksaan===true) {
        this.ternakan_list.forEach((row) => {
         if (row.lkp_status_id !=28) {
            if (!row.bunting_art || !row.lkp_kaedah_pemeriksaan_id) {
               isValid = false;
               this.loading=false;
            }
         }
        });
      }
      if (this.datas.caj_lain_pemeriksaan!=0 && this.datas.nyatakan_pemeriksaan == null || this.datas.tarikh_pemeriksaan_art==null) {
         // alert(true);
         isValid = false;
         this.loading=false;
      }

      if (!isValid) {
        this.$zutil.notify("Pastikan semua data sudah diisi", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.onSuccess();
    },
    send(hantar){
      this.datas.hantar = hantar
    },

    onSuccess(){
      this.loading=true;
      if(this.datas.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.datas.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.datas.id, {ternakan_list:this.ternakan_list, pemeriksaan_kebuntingan:1, hantar:1})
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  this.loading=false;
                  if (this.form.hantar==1) {
                      // this.$inertia.visit(this.$route('art.permohonan.show', this.datas.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                      this.$inertia.visit(this.$route('art.semakan.ai-aiman',this.datas.id)+'?tab=3');
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }
            }else{
              this.loading=false;
            }
          })
      }else{
        if (this.datas.id > 0) 
        {
          
          var param = {
            ternakan_list: this.ternakan_list,
            pemeriksaan_kebuntingan:1,
            tarikh_pemeriksaan_art: this.datas.tarikh_pemeriksaan_art,
            konsutasi_pemeriksaan :this.datas.konsutasi_pemeriksaan,
            pengangkutan_pemeriksaan: this.datas.pengangkutan_pemeriksaan,
            keseluruhan_pemeriksaan: this.datas.keseluruhan_pemeriksaan,
            subsidi_pemeriksaan : this.datas.subsidi_pemeriksaan,
            caj_pemeriksaan_pd: this.datas.caj_pemeriksaan_pd,
            perlu_bayar_pemeriksaan : this.datas.perlu_bayar_pemeriksaan,
            konsutasi_pemeriksaan_ya_tidak : this.datas.konsutasi_pemeriksaan_ya_tidak,
            caj_lain_pemeriksaan : this.datas.caj_lain_pemeriksaan,
            bayar_pengangkutan_pemeriksaan: this.datas.bayar_pengangkutan_pemeriksaan,
            bayar_caj_lain_pemeriksaan: this.datas.bayar_caj_lain_pemeriksaan,
            bayar_pemeriksaan_pd: this.datas.bayar_pemeriksaan_pd,
            nyatakan_pemeriksaan : this.datas.nyatakan_pemeriksaan,
          }
          this.$zcomm.update(this.resourceurl + '.update', this.datas.id, param)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            this.loading=false;
            if (this.form.hantar==1) {
                // this.$inertia.visit(this.$route('art.permohonan.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('art.semakan.ai-aiman',this.datas.id)+'?tab=4');
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
      } 
      
    },
  },
      
  mounted() {
    this.lkpPenentuan();
    this.lkpKategoriSemen();
    this.getTernakan();
    this.lkpKaedahPemeriksaan()
    // this.datas = this.data;
  }
}
      

</script>  
<style type="text/css">

/*.w-table__row {
  display: flex;
  align-items: center;
}*/
.w-table__cell {
  vertical-align: middle;
}

</style>
